export default "__VITE_ASSET__Dl6ZhWJ1__"